import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FileService } from 'src/app/services/file.service';
import { checkError, CONSTANTES, getToken } from 'src/app/shared/global';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { saveAs } from 'file-saver/dist/FileSaver';
declare var jQuery: any;

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent implements OnInit {

  public pdfSrc;
  public srcPdfViewer;
  public downloadPdf;

  constructor(private http: HttpClient,private Spinner: NgxSpinnerService, private fileService: FileService, private toastr: ToastrService, private route: ActivatedRoute, private router: Router, private authService: AuthenticationService) {

  }

  ngOnInit() {
    jQuery.getScript(CONSTANTES.menu);
    this.getPdf();
  }

  getPdf(){
    let infoPdf = {
      type: "instructions",
      nid: localStorage.getItem("nid"),
      role: localStorage.getItem("role")
    };

    this.fileService.downloadFile(infoPdf).subscribe(data => {
      if (getToken(data)) {
        if (data.pdf != null) {
          let binString = atob(data.pdf);
          let arr = new Uint8Array(binString.length);
          for (let i = 0; i < binString.length; i++){
            arr[i] = binString.charCodeAt(i);
          }
          this.srcPdfViewer = arr.buffer;
          this.pdfSrc = new Blob([arr], {type: 'application/pdf'});
        } else {
          this.toastr.warning("NO HA SIDO POSIBLE OBTENER LA INFORMACIÓN SOLICITADA, CONSULTE CON EL ADMINISTRADOR", "ERROR");
        }
      } else {
        this.toastr.warning(data.errorCode.message, "ERROR");
        if (!checkError(data.errorCode.code)) {
          let infoUser = {
            userName: localStorage.getItem("nid")
          }
          this.authService.logOut(infoUser).subscribe(
            data => {
              localStorage.clear();
              this.router.navigate(['login']);
            }
          );
        }
      }
      this.Spinner.hide();
    },
      error => {
        this.Spinner.hide();
    });
  }

  download(){
    const fileName = 'MANUAL_DE_USUARIO_' + localStorage.getItem("role") + '.pdf';
    saveAs(this.pdfSrc, fileName);
  }

}
